import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue';

const app = createApp({
    components: {
    },
});
app.mount('#app');
